// removed by extract-text-webpack-plugin
module.exports = {"roles":"_3ztHfh8LhZ8-WMv6YLcIzA","list":"_3BVIX-2WcM2GjSNrZdcdJK"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Users/UserPage/Roles/style/Roles.pcss
// module id = 1363
// module chunks = 0